import { ChangeEvent } from 'react';

interface IRADIO_BUTTON {
  id: string;
  label: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string | number;
  showLabel?: boolean;
  type?: string;
  required?: boolean;
  parentClass?: string;
  childClass?: string;
  optionsArray: Array<{ label: string; value: string | number }>;
}

export const RadioButton = ({
  id,
  label,
  onChange,
  parentClass = '',
  childClass = '',
  value,
  showLabel = true,
  type = 'radio',
  optionsArray,
}: IRADIO_BUTTON): JSX.Element => {
  return (
    <div
      className={`gap-3  ${
        parentClass.includes('!mb-0') ? '!mb-0 sm:!mb-0' : 'mb-12 sm:mb-6'
      } ${parentClass}`}
    >
      <div className="font-medium">
        {showLabel && <label htmlFor={id}>{label}</label>}
      </div>
      <div className="flex gap-20 pt-2 sm:flex-wrap sm:gap-2.5 md:flex-wrap md:gap-11 ">
        {optionsArray?.map((option, index) => (
          <div key={index} className="flex items-center gap-2">
            <input
              id={`input_${id}_${index}`}
              type={type}
              className={`border border-grey-300 border-l-0 rounded-r-sm text-base h-5 w-5 px-2 placeholder-gray-400 placeholder-opacity-75 sm:text-s-14 ${childClass}`}
              name={id}
              value={option.value}
              onChange={onChange}
              checked={value === option.value}
            />
            <label
              htmlFor={`input_${id}_${index}`}
              className={`text-base text-font-500 sm:text-base`}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
